import React, { Component } from "react";
import { ToastContainer, Slide } from "react-toastify";

import AuthContainer from "../AuthContainer/AuthContainer";
import PublicContainer from "../PublicContainer/PublicContainer";
import ProtectedRoutes from "./ProtectedRoutes";
import ProtectedRoutesContainer from "./ProtectedRoutesContainer";
import PageNotFound from "../PageNotFound/PageNotFound";
import SignOut from "../AuthContainer/SignOut";

import "../../../node_modules/semantic-ui-css/semantic.min.css";
import { ReactComponent as Chevron } from "../../assets/svg/chevron.svg";
import { ReactComponent as Delete } from "../../assets/svg/close.svg";
import "./AppContainer.scss";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { isMobile } from "react-device-detect";
import axios from "axios";
import moment from "moment-timezone";
import SignUpContainer from "../AuthContainer/SignUp/SignUpContainer";
import ReactGaContainer from "./ReactGaContainer";

import AuthContainerCloned from "../AuthContainer/AuthContainerCloned";
import SignInContainerCloned from "../AuthContainer/SignUp/SignInContainerCloned";
import { connect } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";

axios.interceptors.response.use(
    function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    },
    function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error

        //  console.log("first", error.response.config.url.includes("radarr.com"),error.response);
        if (error.response?.status === 401 && error.response?.config?.url?.includes("radarr.com")) {
            sessionStorage.setItem("isSessionTimedOut", moment().format("x"));
            window.location.href = window.location.origin + "/signout";
            return false;
        }
        return Promise.reject(error);
    },
);

class AppContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showInfoMessage: true,
            showMaintainenceBar: true,
        };
    }

    getShowInfoMessage = () => {
        let date = moment().utc().unix();
        if (date > 1658473200) return false;
        else return true;
    };

    componentDidMount() {
        zE("webWidget", "hide");
    }

    render() {
        // console.log("clientId", this.props.clientId);
        return (
            <GoogleOAuthProvider clientId={this.props.clientId || "626488198253-v37qlu0s8mc6qt43jj6u2k1asfqfvu7e.apps.googleusercontent.com"}>
                <Router>
                    <ErrorBoundary>
                        <div id="page" className={isMobile ? "mobile-device" : ""}>
                            {/* {this.state.showInfoMessage ? (
                        <div className="info-message">
                            <span>Due to some scheduled maintenance some services might not work as expected.</span>
                            <span className="delete" onClick={() => this.setState({ showInfoMessage: false })}>
                                <Delete />
                            </span>
                        </div>
                    ) : (
                        <div className="info-message-hidden" onClick={() => this.setState({ showInfoMessage: true })}>
                            <Chevron />
                        </div>
                    )} */}
                            <ReactGaContainer />
                            <ToastContainer
                                position="bottom-center"
                                type="default"
                                containerId="mainContentToast"
                                style={{ zIndex: "10000000" }}
                                autoClose={8000}
                                hideProgressBar
                                // closeButton={false}
                                newestOnTop={false}
                                closeOnClick
                                pauseOnHover
                                pauseOnFocusLoss
                                className="toastify-container skiptranslate"
                                toastClassName="toastify-toast"
                                transition={Slide}
                            />
                            <Switch>
                                <Route exact path="/signout" component={SignOut} />
                                {/* <Route exact path="/signup" component={SignUpContainer} /> */}
                                {/* <Route exact path="/signup" render={() => <SignUpContainer component="SignUp" />} /> */}
                                <Route exact path="/signin" render={() => <SignUpContainer component="Signin" />} />
                                <Route exact path="/wlsignin" component={SignInContainerCloned} />
                                <Route exact path="/sso/azure" component={AuthContainerCloned} />
                                <Route
                                    path={["/forgetpassword", "/resetpassword", "/email-verify", "/oauth-linkedin"]}
                                    render={(props) => <AuthContainer {...props} />}
                                />
                                <Route path="/public" component={PublicContainer} />
                                <ProtectedRoutes path="/">
                                    <ProtectedRoutesContainer />
                                </ProtectedRoutes>
                            </Switch>
                        </div>
                    </ErrorBoundary>
                </Router>
            </GoogleOAuthProvider>
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    return { clientId: state.globalReducer.googleClientId };
};
const mapDispatchToProps = (dispatch) => {};
export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);
// export default AppContainer;
